import { useEffect } from 'react';

// Mesma rolagem lateral em duas áreas (na Semana: o cabeçalho dos dias, preso no topo, e a grade). O CSS não prende um
// cabeçalho que está dentro de uma área com rolagem lateral quando quem rola na vertical é a página, então cada um tem a
// sua rolagem e o script copia a posição. Cada lado ignora o evento que ele mesmo provocou no outro: sem isso, na inércia
// do toque, o evento atrasado de um lado puxaria o outro de volta. active: as duas áreas estão na tela
export function useSyncedScroll(headRef, bodyRef, active) {
  useEffect(() => {
    const head = headRef.current;
    const body = bodyRef.current;
    if (!active || !head || !body) return undefined;

    let expectHead = null;
    let expectBody = null;
    const follow = (from, to, setExpected) => {
      setExpected(from.scrollLeft);
      to.scrollLeft = from.scrollLeft;
    };
    const onBody = () => {
      if (expectBody !== null && Math.abs(body.scrollLeft - expectBody) < 1) {
        expectBody = null;
        return;
      }
      follow(body, head, (value) => { expectHead = value; });
    };
    const onHead = () => {
      if (expectHead !== null && Math.abs(head.scrollLeft - expectHead) < 1) {
        expectHead = null;
        return;
      }
      follow(head, body, (value) => { expectBody = value; });
    };

    head.scrollLeft = body.scrollLeft;
    body.addEventListener('scroll', onBody, { passive: true });
    head.addEventListener('scroll', onHead, { passive: true });
    return () => {
      body.removeEventListener('scroll', onBody);
      head.removeEventListener('scroll', onHead);
    };
  }, [headRef, bodyRef, active]);
}
